import * as React from "react";
import { Route, Switch } from "react-router-dom";

import Fraud from "app/components/AppComponents/SnapScan/Fraud/Fraud";
import Ops from "app/components/AppComponents/SnapScan/Ops/Ops";
import Wallet from "app/components/AppComponents/SnapScan/Wallet/Wallet";
import Settlements from "app/components/AppComponents/SnapScan/Settlements/Settlements";
import TicketEvents from "./TicketEvents/TicketEvents";

const SnapScan = (props) => (
  <Switch>
    <Route path="/snapscan/fraud" render={() => <Fraud {...props} />} />
    <Route path="/snapscan/ops" render={() => <Ops {...props} />} />
    <Route
      path="/snapscan/wallets"
      render={() => <Wallet {...{ ...props, vouchering: false }} />}
    />
    <Route
      path="/snapscan/vouchers"
      render={() => <Wallet {...{ ...props, vouchering: true }} />}
    />
    <Route
      path="/snapscan/wallet_withdrawals"
      render={() => <Wallet {...{ ...props, vouchering: false }} />}
    />
    <Route
      path="/snapscan/settlements"
      render={() => <Settlements {...props} />}
    />
    <Route path="/snapscan/events" render={() => <TicketEvents {...props} />} />
  </Switch>
);

export default SnapScan;
